import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../Box/index.js";
import { Stage } from "../Stage/index.js";
const Stages = (t0)=>{
    const $ = c(24);
    const { active, showHeader: t1, size: t2, steps, fullWidth: t3 } = t0;
    const showHeader = void 0 === t1 ? false : t1;
    const size = void 0 === t2 ? "medium" : t2;
    const fullWidth = void 0 === t3 ? false : t3;
    let t4;
    bb0: {
        if (!active) {
            let t5;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t5 = [];
                $[0] = t5;
            } else t5 = $[0];
            t4 = t5;
            break bb0;
        }
        let t5;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = [];
            $[1] = t5;
        } else t5 = $[1];
        let result = t5;
        let t6;
        if ($[2] !== active) {
            t6 = (t7)=>{
                const { name } = t7;
                return name === active;
            };
            $[2] = active;
            $[3] = t6;
        } else t6 = $[3];
        const activeIndex = steps.findIndex(t6);
        if (activeIndex > -1) {
            let t7;
            if ($[4] !== activeIndex || $[5] !== steps) {
                let t8;
                if ($[7] !== activeIndex) {
                    t8 = (_, index)=>index < activeIndex;
                    $[7] = activeIndex;
                    $[8] = t8;
                } else t8 = $[8];
                t7 = steps.filter(t8).map(_temp);
                $[4] = activeIndex;
                $[5] = steps;
                $[6] = t7;
            } else t7 = $[6];
            result = t7;
        }
        t4 = result;
    }
    const completedSteps = t4;
    let t5;
    if ($[9] !== active || $[10] !== completedSteps) {
        t5 = (step)=>{
            if (completedSteps.includes(step)) return "completed";
            if (step === active) return "active";
            return "initial";
        };
        $[9] = active;
        $[10] = completedSteps;
        $[11] = t5;
    } else t5 = $[11];
    const getStatus = t5;
    if (!(null == steps ? void 0 : steps.length)) return null;
    let t6;
    if ($[12] !== fullWidth || $[13] !== getStatus || $[14] !== showHeader || $[15] !== size || $[16] !== steps) {
        const items = steps.map(_temp2);
        const first = items.shift();
        const last = items.pop();
        t6 = showHeader && /*#__PURE__*/ jsxs(Box, {
            mb: "24",
            className: "aqa_stages",
            display: "flex",
            children: [
                first && /*#__PURE__*/ jsx(Stage, {
                    first: true,
                    label: first.label,
                    fullWidth: fullWidth,
                    last: 1 === steps.length,
                    size: size,
                    status: getStatus(first.name)
                }, first.name),
                items.map((step_1)=>/*#__PURE__*/ jsx(Stage, {
                        fullWidth: fullWidth,
                        label: step_1.label,
                        size: size,
                        status: getStatus(step_1.name)
                    }, step_1.name)),
                last && /*#__PURE__*/ jsx(Stage, {
                    fullWidth: fullWidth,
                    label: last.label,
                    last: true,
                    size: size,
                    status: getStatus(last.name)
                }, last.name)
            ]
        });
        $[12] = fullWidth;
        $[13] = getStatus;
        $[14] = showHeader;
        $[15] = size;
        $[16] = steps;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== active || $[19] !== steps) {
        var _steps_find;
        t7 = (null == (_steps_find = steps.find((t8)=>{
            const { name: name_1 } = t8;
            return name_1 === active;
        })) ? void 0 : _steps_find.content) || "";
        $[18] = active;
        $[19] = steps;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t6 || $[22] !== t7) {
        t8 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t6,
                t7
            ]
        });
        $[21] = t6;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
};
function _temp(t0) {
    const { name: name_0 } = t0;
    return name_0;
}
function _temp2(step_0) {
    return step_0;
}
export { Stages };
